<template>
  <div class="wrap">
    <table class="table-inner">
      <colgroup width="10%"></colgroup>
      <colgroup width="50%"></colgroup>
      <colgroup width="40%"></colgroup>
      <thead>
        <th>№</th>
        <th>Задача</th>
        <th>Контрольный срок</th>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id" @dblclick="viewCard(item)">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ $momentFormat(item.deadline, Constants.DATE_FORMATS['D MMMM YYYY HH:mm']) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Constants from '@/common/constants';

  import API from '../api/widgetElement';

  export default {
    name: 'Widget19',
    methods: {
      loadItems() {
        API.getTaskToApprove().then((response) => {
          this.items = response.data;
        });
      },
      viewCard(el) {
        this.$router.push({ name: el.isEap ? 'IssueEapCard' : 'IssueCard', params: { id: el.id, action: 'view' } });
      },
    },
    data() {
      return {
        items: [],
        Constants: Constants,
      };
    },
    created() {
      this.loadItems();
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/colors';
  .wrap {
    max-height: 165px;
  }
  .table-inner {
    min-width: 520px;

    width: 100%;
    margin-top: 12px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: $dark;
    padding: 16px;
    .active {
      background-color: #ededed;
    }
    thead th {
      border-bottom: 1px solid #dedede;
      padding: 10px 0;
    }
    tbody tr td {
      padding: 10px 0;
    }
    th:nth-child(1),
    td:nth-child(1) {
      padding-left: 12px;
    }
    tbody tr:nth-of-type(even) {
      background: #ededed;
    }
  }
</style>
